// submitLivestreamRating.js
'use strict';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_LIVE_STREAM_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Submit livestream rating
 * @kind action
 * @param {string} {streamId} - stream id.
 * @param {number} {rating} - rating.
 * @return {Promise} Action promise.
 */
const submitLivestreamRating =
  ({ streamId, rating } = {}) =>
  async (dispatch, getState) => {
    const sessionId = getLiveStreamData(getState(), [streamId], 'sessionId');
    const token = getMeData(getState(), 'token');
    if (!token || !streamId || !sessionId) {
      return dispatch({ type: '' });
    }
    const networkingSelectPath = [
      'submit',
      'livestream',
      streamId,
      'rating',
      sessionId,
    ];
    const fetchOptions = {
      method: 'PUT',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        rating,
      }),
    };
    const fetchUrl = getResourceUrl({
      endpoint: `/sessions/${sessionId}/rate`,
    });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }
      dispatch({
        type: MERGE_LIVE_STREAM_DATA,
        payload: {
          selectPath: [streamId, 'rating', sessionId],
          data: {
            ratedAs: rating,
          },
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default submitLivestreamRating;
